import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatDividerModule } from '@angular/material/divider'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { EmployeeStatusService } from '../../../core/services/employee/employee-status/employee-status.service'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { HabitsService } from '../../../core/services/employee/employee-role/habits.service'
import { HealthUnitService } from '../../../core/services/health-unit/location/health-unit.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {NgxMaskDirective} from 'ngx-mask';
import {MunicipalityService} from '../../../core/services/municipality/municipality/municipality.service';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {MessageService} from '../../../core/services/message/message/message.service';
import {ContentSugestionService} from '../../../core/services/content-sugestion/message/content-sugestion.service';
import {ContentTypeService} from '../../../core/services/content-type/document-type/content-type.service';

@Component({
  selector: 'content-sugestion-edit',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatDividerModule,
    MatSlideToggle,
    NgxMaskDirective,
    MatOption,
    MatSelect,
  ],
  templateUrl: './content-sugestion-edit.component.html',
  styleUrl: './content-sugestion-edit.component.scss',
  providers: [
    MessageService,
  ],
  standalone: true,
})
export class ContentSugestionEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private contentSugestionService: ContentSugestionService,
    private contentTypeService: ContentTypeService,
    private snackbar: SnackbarCustomService,
    private viaCepService: ViaCepService,
    private dialogRef: MatDialogRef<ContentSugestionEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = this.data.item
  }

  @Output() responseEdit = new EventEmitter()

  item: any = {}
  form: FormGroup = new FormGroup({})
  listUseTypes: any[] = []

  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
    this.useTypes()
  }
  useTypes(){
    this.contentTypeService.listContentType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listUseTypes = response.data
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.item.id,
      descricao: this.form.get('description')?.value,
      titulo: this.form.get('title')?.value,
      subtitulo: this.form.get('subtitle')?.value,
      tipo_conteudo: this.form.get('contentType')?.value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      code: this.item.id,
      title: [this.item.titulo, [Validators.required]],
      subtitle: [this.item.subtitulo, [Validators.required]],
      contentType: [this.item.tipo_conteudo, [Validators.required]],
      description: [this.item.descricao, [Validators.required]],
    })
    this.form.get('code')?.disable()
  }

  editLocation() {
    this.loading = true
    this.contentSugestionService.editContentSugestion(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }
}
